import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DoubleValueLabelPair } from '@app/models/data-types/double-value-label-pair';

@Component({
	selector: 'app-select',
	standalone: true,
	imports: [],
	templateUrl: './select.component.html',
	styleUrl: './select.component.css',
})
export class SelectComponent {
	@Input() options: DoubleValueLabelPair[] = [];
	@Input() selectElementId: string = '';
	@Input() label: string = '';

	@Output() optionSelected = new EventEmitter<string>();

	onSelect(event: Event) {
		event.preventDefault();
		let target = event.target as HTMLInputElement;
		let primaryValue = target.value;
		this.optionSelected.emit(primaryValue);
	}
}
